import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reportOutputType'
})
export class ReportOutputTypePipe implements PipeTransform {

  transform(value: string): string {
    switch (value) {
      case 'table':
        return 'جدول';
      default:
        return value;
    }
  }

}
